import { DefaultClinicSelector } from '@/frontend/components/default-clinic-selector'

/** Custom page rendered inside the Clerk UserButton modal for user preferences. */
export function UserSettings() {
  return (
    <div className="space-y-4 p-1">
      <div>
        <label htmlFor="default-clinic" className="mb-1.5 block font-medium">
          Default clinic
        </label>
        <p className="mb-2 text-sm text-muted-foreground">
          Pre-selects this clinic in forms and filters across the app.
        </p>
        <DefaultClinicSelector id="default-clinic" className="h-9 w-64" />
      </div>
    </div>
  )
}
